import {
  GrammarSimpleEventTypeLegacy,
  SimpleEventTypeLegacy,
  SimpleEventType,
} from '@verantos-dev/types-cohorts';

export const transformSimpleEventTypeToGrammarSimpleEventType = (
  simpleEventType: SimpleEventTypeLegacy | SimpleEventType | undefined
): GrammarSimpleEventTypeLegacy => {
  switch (simpleEventType) {
    case SimpleEventType.CONDITION_OCCURRENCE:
      return GrammarSimpleEventTypeLegacy.CONDITION_OCCURRENCE;
    case SimpleEventType.DRUG_EXPOSURE:
      return GrammarSimpleEventTypeLegacy.DRUG_EXPOSURE;
    case SimpleEventType.PROCEDURE_OCCURRENCE:
      return GrammarSimpleEventTypeLegacy.PROCEDURE_OCCURRENCE;
    case SimpleEventType.MEASUREMENT:
      return GrammarSimpleEventTypeLegacy.MEASUREMENT;
    case SimpleEventType.OBSERVATION:
      return GrammarSimpleEventTypeLegacy.OBSERVATION;
    case SimpleEventType.VISIT_OCCURRENCE:
      return GrammarSimpleEventTypeLegacy.VISIT_OCCURRENCE;
    default:
      throw new Error(`Cannot submit without a simple event type`);
  }
};
